// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1kmZu","incriment":"styles_incriment__2wPUa"};